import axios from 'axios'

// Get all transactions for business
const getAll = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/transaction/business/${iniDate}/${endDate}`)
  return data
}

export {
  getAll
}
